import PropTypes from 'prop-types';
import React from 'react';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import ReadonlyField from '../ReadonlyField';
import SelectField from '../SelectField';

PrivilegedSelectField.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
    translatedReadonlyValue: PropTypes.string,
};

PrivilegedSelectField.defaultProps = {
    value: undefined,
    sufficientReadPrivileges: null,
    translatedReadonlyValue: null,
};

function PrivilegedSelectField(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        value,
        translatedReadonlyValue,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    const canWrite = hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    return (
        canWrite
            ? (
                <SelectField
                    value={value}
                    {...rest}
                />
            )
            : (
                canRead && (
                    <ReadonlyField
                        value={translatedReadonlyValue || value}
                        {...rest}
                    />
                )
            )
    );
}

export default PrivilegedSelectField;
